import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ss-tela-conteudo" }
const _hoisted_8 = { class: "ss-card ss-card-space" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_disponibilidade_produtos = _resolveComponent("disponibilidade-produtos")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_resumo_ajustes_inventario_modal = _resolveComponent("resumo-ajustes-inventario-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_titulo_padrao, {
            identificadorRecurso: "AJUSTE_INVENTARIO",
            tituloRecurso: "Ajuste de Inventário",
            exibirAtalhosTela: true,
            exibirHistoricoTela: true,
            empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
            "onUpdate:empresasSelecionadas": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
          }, {
            BotoesAcoes: _withCtx(() => [
              _createElementVNode("div", {
                class: "ss-principais-acoes",
                style: _normalizeStyle(_ctx.storeSistema.state.layoutMobile ? 'margin-left: auto; margin-right: auto;' : '')
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-primary ss-btn-tela",
                    title: "Consulta de Produtos",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.aplicarAjustes && _ctx.aplicarAjustes(...args)))
                  }, "Aplicar Ajustes")
                ])
              ], 4)
            ]),
            _: 1
          }, 8, ["empresasSelecionadas"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createVNode(_component_selecionar_empresa, {
                codigoSelecionado: _ctx.state.empresa,
                "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.empresa) = $event)),
                empresasEspecificas: _ctx.telaBase.empresasDisponiveis
              }, null, 8, ["codigoSelecionado", "empresasEspecificas"]), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              (_openBlock(), _createBlock(_component_disponibilidade_produtos, {
                key: _ctx.state.keyDisponibilidade,
                empresa: _ctx.state.empresa,
                "modo-ajuste": true,
                controles: _ctx.state.controles,
                "onUpdate:controles": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.controles) = $event)),
                produtos: _ctx.state.produtos,
                "onUpdate:produtos": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.produtos) = $event)),
                dataSaldo: _ctx.state.dataSaldo,
                "onUpdate:dataSaldo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dataSaldo) = $event))
              }, null, 8, ["empresa", "controles", "produtos", "dataSaldo"]))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"]),
    _createVNode(_component_resumo_ajustes_inventario_modal, {
      visivel: _ctx.state.exibirResumo,
      "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.exibirResumo) = $event)),
      empresa: _ctx.state.empresa,
      produtos: _ctx.state.produtos,
      "data-saldo": _ctx.state.dataSaldo,
      onConfirmacao: _ctx.confirmar
    }, null, 8, ["visivel", "empresa", "produtos", "data-saldo", "onConfirmacao"])
  ], 64))
}